export default __webpack_public_path__ + "static/media/identify-0-period-tab.c839ce82.png";